import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { categoriesArrayPropTypes } from 'helpers/propTypes';

import './Footer.scss';
import FooterD5 from './FooterD5';
import { getStoreDesign } from 'constants/storeDesigns';
import { getCustomDesignSettings, isCustomDesign } from 'constants/customDesign';
import { CustomHtmlSection, CustomHtmlStyles } from 'components/commons/CustomHtml';

const Footer = (props) => {
  const {
    marcasHome, subCategoriesHome, client, envios, paymentMethods, frequentQuestions,
  } = props;
  const hasFrequentQuestions = Array.isArray(frequentQuestions) && frequentQuestions.length > 0;
  const storeDesign = getStoreDesign(client?.design);
  const customDesignActive = isCustomDesign(client);
  const customSettings = customDesignActive ? getCustomDesignSettings(client) : null;

  return (
    <>
      <CustomHtmlStyles settings={customSettings?.customHtml} />
      <CustomHtmlSection settings={customSettings?.customHtml} section="beforeFooter" />
      <FooterD5
        marcasHome={marcasHome}
        subCategoriesHome={subCategoriesHome}
        client={client}
        envios={envios}
        paymentMethods={paymentMethods}
        variant={customDesignActive ? 'custom-design' : storeDesign?.slug}
        hasFrequentQuestions={hasFrequentQuestions}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  marcasHome: state.category.marcasHome,
  subCategoriesHome: state.subCategory.itemsHome,
  client: state.app.client,
  envios: state.app.envios,
  paymentMethods: state.app.paymentMethods,
  frequentQuestions: state.app.frequentQuestions,
});

Footer.propTypes = {
  marcasHome: categoriesArrayPropTypes.isRequired,
  subCategoriesHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default connect(mapStateToProps)(Footer);
